/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Content_Hint1Inputs */

const vi_cmspost_content_hint1 = /** @type {(inputs: Cmspost_Content_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chèn ảnh / video từ thư viện bằng nút trên thanh công cụ (hoặc kéo-thả, dán ảnh); định dạng không hỗ trợ bị lọc khi lưu.`)
};

/**

* @param {Cmspost_Content_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_content_hint1 = /** @type {((inputs?: Cmspost_Content_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Content_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_content_hint1(inputs)
});
export { cmspost_content_hint1 as "cmsPost_content_hint" }